import { useEffect, useState } from 'react';
import './resources/css/_colors.scss';
import './resources/css/custom.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Routes } from 'react-router-dom';
import styled from 'styled-components';
import Layout from './components/layout/Layout';
import PageTitle from './components/layout/PageTitle';
import { HandleSharedWebSiteLink } from './components/share-website/HandleSharedWebSiteLink';
import Theme from './theme/theme';
import { setLoggedInUser } from './state/slices/rpcSlice';
import { useAppDispatch, useAppSelector } from './state/hooks';
import { IS_EXTRANET } from './utils/appInfoUtil';
import { SV_ROOT_ROUTE, VM_ROOT_ROUTE } from './utils/constants';

const StyledAppContainer = styled.div`
  width: 100%;
  height: var(--app-height);
  margin: 0;
  padding: 0;

  a {
    color: #0064af;
  }
`;

/**
 * Top class for the application.
 * Everything else is under this.
 *
 * @class App
 * @extends {React.Component}
 */
const App = () => {
  const dispatch = useAppDispatch();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const channel = useAppSelector((state) => state.rpc.channel);
  useEffect(() => {
    if (!IS_EXTRANET) return;
    async function fetchData() {
      if (!isLoggedIn) {
        (channel as any).getCurrentUser(
          (data: any) => {
            dispatch(setLoggedInUser(data));
            setIsLoggedIn(true);
          },
          (err: any) => {
            console.log(err);
            setIsLoggedIn(false);
            globalThis.location.href = '/login';
          }
        );
      }
      //   {
      //   loggedInUser: {
      //      uid: 'K1233454567',
      //      _email: 'mock@example.com',
      //      _firstName: 'Etu',
      //      _lastName: "Suku"
      //    },
      //   _roles: ["user", "reader", "kaivaja"],
      //   }
    }
    channel && fetchData();
  }, [dispatch, isLoggedIn, channel]);
  let rootRoute = IS_EXTRANET ? VM_ROOT_ROUTE : SV_ROOT_ROUTE;
  const appContainer = (
    <StyledAppContainer>
      <HandleSharedWebSiteLink />
      <PageTitle />
      <Layout />
    </StyledAppContainer>
  );

  return (
    <Theme>
      <Routes>
        <Route
          path={rootRoute}
          element={
            <StyledAppContainer>
              <PageTitle />
              <Layout />
            </StyledAppContainer>
          }
        />
        <Route
          path={'/theme/:zoom/:x/:y/:themeId/:lang?'}
          element={appContainer}
        />
        <Route
          path={'/link/:zoom/:x/:y/:maplayers/:lang?'}
          element={appContainer}
        />
      </Routes>
    </Theme>
  );
};

export default App;
